import { axiosInstance as axios } from "services";

export const fetchCompanyNotes = async (companyId) => {
  const { data } = await axios.get(`/admin/subscription/company/${companyId}/notes`);
  if (!data.success) throw new Error(data.error?.message || "Failed to fetch notes");
  return data;
};

